module.exports = __webpack_public_path__ + "static/moon-4a5cefe36d70891316d1b80cc8855fd4.png";